var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewProjectAudit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2942",
    "data-name": "Group 2942",
    transform: "translate(-1468 -317)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_818",
    "data-name": "Rectangle 818",
    width: 93.935,
    height: 93.962,
    transform: "translate(1473.032 327.039)",
    fill: "#00feff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M104,6.692a3.349,3.349,0,0,1-3.355,3.346H3.355A3.349,3.349,0,0,1,0,6.692V3.346A3.348,3.348,0,0,1,3.355,0h97.29A3.348,3.348,0,0,1,104,3.346Z",
    transform: "translate(1468 317)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M122.645,156.467a1.675,1.675,0,0,1-1.677-1.673V134.717a1.677,1.677,0,0,1,3.355,0v20.077a1.675,1.675,0,0,1-1.677,1.673",
    transform: "translate(1397.354 239.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M163.613,168.532H146.838a1.673,1.673,0,1,1,0-3.346h15.1v-18.4a1.677,1.677,0,0,1,3.355,0v20.077a1.675,1.675,0,0,1-1.677,1.673",
    transform: "translate(1383.226 232.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M58.129,96.14a1.675,1.675,0,0,1-1.677-1.673V74.39a1.675,1.675,0,0,1,1.677-1.673H74.9a1.673,1.673,0,1,1,0,3.346h-15.1v18.4a1.675,1.675,0,0,1-1.677,1.673",
    transform: "translate(1435.032 274.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M122.645,108.2a1.675,1.675,0,0,1-1.677-1.673V86.455a1.677,1.677,0,0,1,3.355,0v20.077a1.675,1.675,0,0,1-1.677,1.673",
    transform: "translate(1397.354 267.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M99.1,136.389H82.322a1.673,1.673,0,1,1,0-3.346H99.1a1.673,1.673,0,1,1,0,3.346",
    transform: "translate(1420.903 239.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M139.42,136.389H122.645a1.673,1.673,0,1,1,0-3.346H139.42a1.673,1.673,0,1,1,0,3.346",
    transform: "translate(1397.354 239.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_819",
    "data-name": "Rectangle 819",
    width: 20.129,
    height: 10.038,
    transform: "translate(1536.774 369)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_820",
    "data-name": "Rectangle 820",
    width: 20.129,
    height: 10.038,
    transform: "translate(1483.097 369)",
    fill: "#0f0fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M100.807,130.019,110.871,125l10.064,5.019-10.064,5.019Z",
    transform: "translate(1409.129 244)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M115.9,74.712H105.839a5.019,5.019,0,1,1,0-10.039H115.9a5.019,5.019,0,1,1,0,10.039",
    transform: "translate(1409.129 279.231)",
    fill: "#9734eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M115.9,195.365H105.839a5.019,5.019,0,1,1,0-10.038H115.9a5.019,5.019,0,1,1,0,10.038",
    transform: "translate(1409.129 208.769)",
    fill: "#9734eb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProjectAudit);
export default __webpack_public_path__ + "static/media/new-project-audit.b2f3666d1274c8c5a0146ee7b0e5cd0b.svg";
export { ForwardRef as ReactComponent };